import React from "react";
import { Checkbox } from "antd";
import { CustomFormItemInputWithBorder } from "../Form";

class CheckBoxComponent extends React.Component {
  render() {
    const {
      getFieldDecorator,
      decodator,
      title,
      value,
      textDescripton,
      required,
      style,
    } = this.props;
    return (
      <div style={style || { marginBottom: 20 }}>
        <CustomFormItemInputWithBorder
          labelCol={{
            xs: { span: 24 },
            sm: { span: 24 },
            lg: { span: 24 },
            xl: { span: 24 },
          }}
          wrapperCol={{
            xs: { span: 24 },
            sm: { span: 24 },
            lg: { span: 24 },
            xl: { span: 24 },
          }}
          label={title}
        >
          {getFieldDecorator(decodator, {
            initialValue: value || undefined,
            rules: [
              {
                required,
                message: "Por favor, ingrese la razón social",
              },
            ],
          })(<Checkbox>{textDescripton}</Checkbox>)}
        </CustomFormItemInputWithBorder>
      </div>
    );
  }
}

export default CheckBoxComponent;
